import { FetchRequestError } from "@lib/errors";
import fetch from "@lib/fetch";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { currentDeveloperCacheKey, developersCacheKey } from "./constants";
import type { DeveloperSaveFailureType, SaveDeveloperPayload } from "./types";

export const putDeveloper = reactQueryMutationAdapter(
  [currentDeveloperCacheKey, developersCacheKey],
  async (developer: SaveDeveloperPayload) => {
    const body = Object.entries(developer)
      .map(([key, value]) => `${encodeURIComponent(`developer[${key}]`)}=${encodeURIComponent(value)}`)
      .join("&");

    const data: DeveloperSaveFailureType | string[][] = await fetch("/developers", "PUT", undefined, {
      headers: { "Content-Type": "multipart/form-data" },
      body,
    });

    // this endpoint currently "succeeds" (returns 200) on failure, so set up handling for that case
    if (data && !Array.isArray(data)) {
      throw new FetchRequestError(200, "", data);
    }
    return data;
  }
);
